// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"955ebbd1","131":"001ac8ed","183":"d3523b07","592":"ac8fc07a"}[chunkId] + ".chunk.js";
};